<template>
  <div class="page">
    <nut-dialog title="温馨提示" :visible="pageShow" @ok-btn-click="pageClick" :closeOnClickModal="false" :noCancelBtn="true" okBtnTxt="好的，我知道了">
      <img class="no-data" src="../../assets/img/no-data.png">
      <div href="javascript:;">{{pageShowMsg}}</div>
      <div>{{$route.query.iccid}}</div>
    </nut-dialog>

    <div class="page" v-if="!pageShow">

      <div class="popup" v-show="isShowPop">
        <div class="pupbg"></div>
        <div class="plane-content">
          <div class="plane-header">
            <button type="button" class="close" @click="closePop">×</button>
          </div>
          <div class="plane-body">
              <div class="plane-body-text">根据国家工信部相关规定,所有流量卡需进行实名身份认证,未实名流量卡将依法停止通信服务</div>
              <div class="realName-tip">
                  <h6>实名说明</h6>
                  <p>1.为贯彻工信部《电话用户真实身份信息登记规定》的规定,<span class="cred">流量卡应与使用人一一对应，必须办理实际使用人的实名登记。</span></p>
                  <p>2.随产品附赠流量卡仅限于本机使用,请您按规定进行实名,<span class="cred">如因未实名导致流量卡通信服务停用带来的所有损失,由用户个人承担!</span></p>
              </div>
          </div>
          <div class="plane-footer">
            <div class="col-xs-12">
              <button class="btn-right" @click="jumpToAuth" v-if="propsParams.operationName != '中国联通'">实名注册</button>
              <div @click="jumpToAuth"  v-else >
                <wx-open-launch-weapp id="launch-btn" username="gh_5eac63f4d504" path="pages/login/index"
                                      style="position: relative;align-items: center;justify-content: center;display: flex;width: 50%; height: 40px;
                                      line-height: 40px;box-sizing: border-box;flex-direction: row;padding: 0 12px;font-size: 14px;border-color: #ebedf0;
                                      border-width: 1px;border-style: solid;background: #f94040;">
                  <script type="text/wxtag-template">
                    <style>
                      .lt-cert-button {
                        color: white;
                        border-bottom-left-radius: 3px;
                        border-bottom-right-radius: 3px;
                        border-top-left-radius: 3px;
                        border-top-right-radius: 3px;
                      }
                    </style>
                    <div class="lt-cert-button">实名注册</div>
                  </script>
                </wx-open-launch-weapp>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="layout-header">
        <div class="lyh_top">
          <div class="lyh_l">
            <img v-if="mobileType === 1" src="../../assets/img/mobie.png" class="telecom-logo"/>
            <img v-if="mobileType === 2" src="../../assets/img/telecom-logo.svg" class="telecom-logo"/>
            <img v-if="mobileType === 3" src="../../assets/img/unicom-logo.svg" class="telecom-logo"/>
          </div>
          <div class="lyh_r">
            <p class="sub-tlt">
              <span class="left">业务号：</span>{{propsParams.msisdn}}
              <span v-if="externalShow" id="card-switch" class="iconfont icon-switch" @click="switchHome()">切换</span>
            </p>
            <p class="sub-tlt"><span class="left">ICCID：</span>{{propsParams.iccid}}</p>
            <nut-picker :is-visible="isVisible" :list-data="listData" :default-value-data="defaultValueData" @close="closeSwitch('isVisible')" @confirm="confirm"></nut-picker>
            <p class="sub-tlt" v-if="ylShow && externalShow">
              <span class="left">积分：</span>{{propsParams.integral}}
              <span class="ck_class" @click="ck_get">去使用 (个人中心)</span>
              <!-- <span class="ck_class"  @click="openSwitch('isVisible')">切换</span> -->
              <!-- <span class="ck_class" v-show="xw_xianshi" @click="binding()" v-if="propsParams.bind != 1">绑定</span> -->
            </p>
            <p class="sub-tlt"><span class="left">套餐过期时间：</span>{{propsParams.expireTime}}</p>
          </div>
        </div>
        <div class="status-line">
          <div class="status-wrap">
            <p :class="{zt_class:propsParams.kycStatus == '未通过审核'}" @click="jumpToAuth()">{{propsParams.kycStatus}}</p>
            <p :class="{zt_class:propsParams.cardStatus == '已停机'||propsParams.cardStatus == '已销户'}">{{propsParams.cardStatus}}</p>
          </div>
          <div class="mark-box">
            <span @click="rescindButton()" v-if="hasAgreementShow">我的签约</span>
            <nut-button class="iconfont icon-jiance" @click="detection()">智能检测</nut-button>
          </div>
        </div>

      </div>
      <nut-row v-if="propsParams.simProduct == '1'">
        <nut-col :span="24">
            <nut-row>
              <nut-col span="24" align="center">
                  <div class="flex-content">
                    <span style="font-size: 16px;">剩余流量：</span>
                    <span class="flex-content-flow" >{{zjdata.surplusFlow}}</span>
                  </div>
              </nut-col>
          </nut-row>
          <nut-row>
              <nut-col span="11" :offset="1" align="left">
                  <div>
                    <span>总流量：</span>
                    <span>{{zjdata.totalFlow}}</span>
                  </div>
              </nut-col>
              <nut-col span="11" :offset="-1" align="right">
                  <div>
                    <span>已使用：</span>
                    <span>{{zjdata.useFlow}}</span>
                  </div>
              </nut-col>
          </nut-row>
          <nut-row>
              <nut-col span="11" :offset="1" align="left">
                  <div>
                    <span>短信功能：</span>
                    <span>{{propsParams.simProduct == '1'?'已开通':'未开通'}}</span>
                  </div>
              </nut-col>
              <nut-col span="11" :offset="-1" align="right">
                  <div>
                    <span>短信剩余：</span>
                    <span>{{zjdata.simSurplus}}个</span>
                  </div>
              </nut-col>
          </nut-row>
          <nut-row>
              <nut-col span="11" :offset="1" align="left">
                  <div>
                    <span>短信总量：</span>
                    <span>{{zjdata.simTotal}}个</span>
                  </div>
              </nut-col>
              <nut-col span="11" :offset="-1" align="right">
                  <div>
                    <span>短信已用：</span>
                    <span>{{zjdata.simUse}}个</span>
                  </div>
              </nut-col>
          </nut-row>
          <nut-row class="row-button">
              <nut-col span="8" align="center">
                <span>
                  <img :src="imgPath" class="row-button-img" @click="handleMessageBuy"/>
                </span>
                <span>短信充值</span>
              </nut-col>
              <nut-col span="8" align="center">
                <span>
                  <img :src="message" class="row-button-img" @click="handleMessageSend"/>
                </span>
                <span>短信发送</span>
              </nut-col>
              <nut-col span="8"  align="center">
                <span>
                  <img :src="customerPath" class="row-button-img-customer" @click="jumpService"/>
                </span>
                <span>流量客服</span>
              </nut-col>
          </nut-row>
        </nut-col>
      </nut-row>
      <div class="detail-flow" v-if="propsParams.simProduct != '1'">
        <p class="p1">
          <span>剩余流量</span>
          <span class="p1-sy">{{zjdata.surplusFlow}}</span>
        </p>
        <p class="p2">
          <span>总流量：{{zjdata.totalFlow}}</span>
          <span class="p2-y">已使用：{{zjdata.useFlow}}</span>
        </p>
        <div class="kefu" v-if="chatShow && externalShow">
          <i @click="jumpService"></i>
          <span>流量客服</span>
        </div>
      </div>
      <div class="detail-box" v-if="box_xian">
        <nut-tab line-width="20" @tab-switch="tabSwitch" :defIndex="tabIndex">
          <nut-tab-panel v-for="(item,index) in lists" :key="index" :tab-title="item">
            <ul style="padding-bottom: 185px;">
              <li class="li_class" v-for="(item1,index1) in packageList" :key="index1" @click="details(item1.monthFlow,item1.id)">
                <div class="li_class_left">
                  <span class="li_class_mame" >{{item1.productName}}</span>
                  <span class="li_class_time" v-if="showEndTime">有效期至：{{item1.endTime}}</span>
                </div>
                <nut-progress :percentage="item1.usePercent" stroke-color="#F94040" stroke-width="5" status="active" v-if="item1.monthFlow != '畅享'"></nut-progress>
                <div class="is-state" v-if="item1.monthFlow == '畅享'">
                  <!-- <div class="is-div1"></div>
                  <div class="is-div" v-if="item1.speedStatus == '0'">4G速度</div>
                  <div class="is-div" v-if="item1.speedStatus == '1'">2G速度</div> -->

                  <!-- <span>4G速度</span>
                  <nut-progress :percentage="item1.usePercent" stroke-color="#F94040" stroke-width="5" status="active" :show-text="false"></nut-progress>
                  <span>2G速度</span> -->
                </div>
                <div class="div-yl">
                  <span>
                    <span>已用：{{item1.useFlow}}</span> ~ <span>总量：{{item1.monthFlow}}</span>
                  </span>
                  <span>{{item1.orderNum}}</span>
                </div>
              </li>
            </ul>
          </nut-tab-panel>
        </nut-tab>
      </div>
      <div class="div_tips" v-if="box_xian">
        <div class="div_tips_wrap">
          <p class="p_tips">温馨提示：</p>
          <p v-if="externalShow" class="p_class"><i class="p_class_i">．</i>如长期不使用，点击了解<button class="shutdownNumber" href="javascript:void(0)" @click="shutdowNum" :disabled = "baonumber">停机保号</button></p>
          <p class="p_class"><i class="p_class_i">．</i>用量数据返回有延迟，以运营商侧数据为准;</p>
          <p class="p_class"><i class="p_class_i">．</i>物联卡机卡绑定，更换设备会锁卡;</p>
          <p class="p_class"><i class="p_class_i">．</i>请勿插在手机等移动端使用，经检测将被关停;</p>
          <div class="btn-line">
            <nut-button v-if="propsParams.showBuy != '0'" @click="handlePay()" :disabled = "recharge">去充值</nut-button>
          </div>
        </div>
      </div>
      <!-- 卡绑定的弹窗 -->
      <nut-popup :style="{ padding: '60px 40px' }" v-model="show">
        <nut-textinput placeholder="请输入姓名" v-model="username"/>
        <nut-textinput placeholder="请输入手机号" v-model="phone" type="tel"/>
        <nut-button @click="bindingCard()">提交</nut-button>
      </nut-popup>
      <!-- 扫码关注公众号的弹窗 -->
      <nut-popup :style="{ padding: '60px 40px' }" v-model="show_ewm" closeable>
        <p style="text-align: center;font-size: 16px;margin: 5px;">扫码关注公众号使用积分</p>
        <!-- <img src="../assets/img/ggh.jpg" alt="" style="max-width: 180px"> -->
        <div id="qrcodeDom"></div>
      </nut-popup>
      <!-- 补卡的弹窗 -->
      <!-- content= "此卡已销户，请点击下方“去补卡”填写您的收件地址并完成支付，工作人员将在两个工作日内安排补卡（补卡费用25元，包含制卡费及快递费）。" -->
      <nut-dialog
        title="温馨提示"
        content= "此卡已销户，如需用卡，请点击下方【去补卡】填写您的收件信息并完成支付申请补卡，工作人员将在两个工作日（节假日除外）安排补卡（补卡费用25元，包含制卡费和快递费）。"
        :visible="dialogShow"
        :noOkBtn = "true"
        cancelBtnTxt = "去补卡"
        @cancel-btn-click = "cancelBtn()"
      >
      </nut-dialog>
      <!-- 新用户领流量的弹窗 -->
      <div class="flowShow-class">
        <nut-dialog
          title="新用户福利"
          :content= "'领取'+propsParams.freeProductFlow+'体验流量，新用户专享'"
          :visible="flowShow"
          :noOkBtn = "true"
          cancelBtnTxt = "去领取"
          @cancel-btn-click = "flowBtn()"
        >
        </nut-dialog>
      </div>
      <!-- 限速的弹窗 -->
      <div class="speedDialog-class">
        <nut-dialog
          title="达量提醒"
          content= "尊敬的用户，您的畅享套餐当月流量已达20GB，暂停上网功能，如需使用，请点击充值【加速包】。"
          :visible="speedDialog"
          :noOkBtn = "true"
          cancelBtnTxt = "去充值"
          @cancel-btn-click = "speedDialogBtn()"
        >
        </nut-dialog>
      </div>
      <!-- 智能检测 -->
      <nut-dialog title="智能检测" textAlign="left" :visible="dialogDetectionShow" :noFooter = "true" :closeBtn="true"  @close="dialogDetectionShow=false">
        <nut-steps :current="3" status="finish" >
          <nut-step :key="index" v-for="(item,index) in titles" :title="item.title" :content="item.value">
          </nut-step>
        </nut-steps>
        <nut-cell style="background-image:none" v-if="showRobotTip">
            <span slot="title" style="color:red">温馨提示：</span>
            <span slot="sub-title" style="line-height: 1.5;">若设备未接入网络。请先确认设备已开启。若有可能，请将设备断电5分钟然后重新启动。</span>
          </nut-cell>
      </nut-dialog>
    </div>

  </div>

</template>
<!--<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>-->
<script>
import {wx_card, wx_getRealNameUrl} from "@/api/api.js"; //获取卡详情
import { wx_flow } from "@/api/api.js"; //获取卡详情
import { wx_product } from "@/api/api.js"; //获取卡套餐
import { wx_refresh } from "@/api/api.js"; //刷新状态
import { wx_bindPhone } from "@/api/api.js"; //微信绑定手机号
import { wx_record } from "@/api/api.js"; //获取微信绑定的卡
import { wx_card_qrcode } from "@/api/api.js"; //获取微信绑定的卡
import { wx_rlwSavePreCertRecord } from "@/api/api.js"; //保存人联网预实名记录
import { wx_card_tipCert } from "@/api/api.js"; //提示实名
import { wx_Auth } from "@/api/api.js"; //获取微信信息
import QRCode from 'qrcodejs2'
import wx from "weixin-js-sdk";
export default {

  data() {
    return {
      pageShow:false,
      pageShowMsg:'免充流量套餐，若有疑问，请联系设备商家。',
      //客服是否展示
      chatShow:true,
      // 补卡的弹窗
      dialogShow: false,
      // 新用户领流量的弹窗
      flowShow: false,
      // 限速的弹窗
      speedDialog:false,
      dialogDetectionShow:false,
      showRobotTip:false,
      titles: [
        {title:'套餐可用流量',value:'0M'},
        {title:'卡片状态',value:'未知'},
        {title:'检测结果',value:'未知'},
        ],
      // 获取卡信息
      zjdata:{},
      propsParams:{
        simProduct:0
      },
      imgsrc:"../../assets/img/ggh.jpg",
      mobileType: 1,
      xw_xianshi:true,
      isShowPop: false,
      platform:'',
      externalShow:true,
      show: false,
      show_ewm:false,
      username:"",
      phone:"",
      // tab切换
      lists:["正使用","待使用","已使用"],
      packageList:[],

      box_xian:true,
      wenxin_xian:true,
      baonumber:false,
      recharge:false,
      // 切换卡
      option: '请选择',
      isVisible: false,
      listData: [],
      defaultValueData: [],
      hasAgreementShow:false,
      ylShow:true,
      imgPath:require('../../assets/svg/msg-buy.svg'),
      message:require('../../assets/svg/msg-send.svg'),
      customerPath: require('../../assets/svg/kf.svg'),
      showEndTime:true,
      tabIndex:0,
    };
  },
  computed: {},
  methods: {
    pageClick(){
      // this.pageShow = false;
      history.back()
    },
    transQrcode(){
        let qrcode = new QRCode('qrcodeDom',{
          width: 344,
          height:344,
          text: `http://weixin.qq.com/q/02oW9ecXKRePl1aSCNxy1W`,  //需要转换的链接
          render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          background: '#f0f',   // 背景色
          foreground: '#ff0'    // 前景色
        })
    },
    // 卡状态转换
    transferCardStatus(status) {
      let obj = {
        1: "库存",
        2: "待激活",
        3: "可测试",
        4: "已激活",
        5: "已停机",
        6: "预销户",
        7: "已销户",
        8: "停机保号",
        9: "已补卡",
      };
      return obj[status];
    },
    // 实名状态
    realnamestatus(status) {
      let obj = {
        0: "未实名",
        1: "审核中",
        2: "已实名",
        3: "未通过审核",
        4: "已注销",
      };
      return obj[status];
    },
    checkIsShowCardCertTip(){
      let params= {
        iccid:this.$route.query.iccid,
      };
      wx_card_tipCert(params).then(res => {
        if (res.data.code == 200) {
          if(this.propsParams.needKyc == 1){
            this.isShowPop = res.data.data;
          }
        }
      });
    },
    closePop(){
      this.isShowPop = false
    },
    // 实名认证
    jumpToAuth(){
      if((this.propsParams.kycStatus == "未实名" || this.propsParams.kycStatus == "未通过审核") &&
          this.propsParams.cardStatus != "已补卡" && this.propsParams.cardStatus != "预销户" &&
          this.propsParams.cardStatus != "已销户"){
        let iccid = this.$route.query.iccid;
        // 卡实名类型 1系统实名  2运营商实名
        if(this.propsParams.cardCertType == 2){
          let params= {
            iccid:this.$route.query.iccid,
          };
          wx_rlwSavePreCertRecord(params).then(res => {
            if (res.data.code == 200) {
              if(this.propsParams.operationName == "中国移动"){
                let params ={
                  iccid:this.$route.query.iccid,
                }
                wx_getRealNameUrl(params).then(res =>{
                  if (res.data.code == 200){
                    let url = res.data.data;
                    window.location.href = url;
                  } else {
                    this.$toast.fail('获取实名链接失败，请稍后重试');
                  }
                })
              } else if(this.propsParams.operationName == "中国电信"){
                this.copy(this.$route.query.iccid)
                window.location.href = "http://uniteapp.ctwing.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1627010616134";
              } else {
                // TODO: 中国联通  不需要处理，跳转到小程序
              }
            }else{
              this.$toast.fail("实名跳转失败！");
            }
          })
        } else {
          this.$router.push({ path: `/auth?iccid=${iccid}` });
        }
      }
    },
    copy(data) {
      let url = data
      let oInput = document.createElement('input')
      oInput.value = url
      document.body.appendChild(oInput)
      oInput.select() // 选择对象
      document.execCommand("Copy") // 执行浏览器复制命令
      this.$toast.success('复制卡号成功！');
      oInput.remove()
    },
    // 绑定卡
    bindingCard(){
      let params ={
        code:this.code,
        iccid:this.$route.query.iccid,
        phone:this.phone,
        username:this.username
      }
      wx_bindPhone(params).then(res =>{
        if(res.data.code == 200){
          this.$toast.success('操作成功！');
          location.reload();
        }else{
          this.$toast.fail('操作失败！');
        }
      })
    },
    // 跳转咨询客服
    jumpService(){
      if(this.platform == 'jz'){
        // window.location.href="http://demo.juzi1688.cn/chat/php/app.php?mobile-chat&platform=jzzl&iccid="+this.$route.query.iccid;
        window.location.href="https://chat.qianhaiyunling.com/im/#/pages/chat?clientId=1747941862162960384&userId="+this.$route.query.iccid;
      }else if(this.platform == 'zw'){
        // window.location.href="http://demo.juzi1688.cn/chat/php/app.php?mobile-chat&platform=wwhl&iccid=" + this.$route.query.iccid;
        window.location.href="https://chat.qianhaiyunling.com/im/#/pages/chat?clientId=1747941705887387648&userId=" + this.$route.query.iccid;
      }else if(this.platform == 'yl' || this.platform == 'qhyl'){
        // window.location.href="http://demo.juzi1688.cn/chat/php/app.php?mobile-chat&platform=qhyl&iccid=" + this.$route.query.iccid;
        window.location.href="https://chat.qianhaiyunling.com/im/#/pages/chat?clientId=1748287554395967488&userId=" + this.$route.query.iccid;
      }else{
        window.location.href="https://chat.qianhaiyunling.com/im/#/pages/chat?clientId=1747941862162960384&userId="+this.$route.query.iccid;
      }
    },
    // 切换卡弹窗
    openSwitch(param) {
      this[`${param}`] = true;
      this.box_xian = false
    },
    // 切换卡弹窗
    closeSwitch(param) {
      this[`${param}`] = false;
      setTimeout(() => {
        this.box_xian = true
      },200)
    },
    parseCallbackUrl(callback, key, val2) {
      if (!callback) {
          return '';
        }
      let allback = callback.replace(/#$/, '');
        if (callback.indexOf('?') == -1) {
          callback = callback + '?' + key + '=' + val2;
        } else if (callback.indexOf('&' + key + '=') == -1 && callback.indexOf('?' + key + '=') == -1) {
          callback = callback + '&' + key + '=' + val2;
        } else {
          var regExp = new RegExp('([&?]' + key + '=)[^&]*', '');
          callback = callback.replace(regExp, ('$1' + val2));
        }
        return callback;
    },
    // 切换卡
    confirm(chooseData) {
      var url= window.location.href;
      window.location.href = this.parseCallbackUrl(url,'iccid',`${chooseData[0].value}`)
      location.reload();
    },
    // 绑定卡
    binding(){
      this.show = true
    },
    // 去充值
    handlePay(){
      // needKyc  0 不要实名  1 需要实名
      // 1 普通套餐 2停机保号  3 补卡套餐
      if(this.propsParams.needKyc == 1){
        if(this.propsParams.kycStatus == '未实名' || this.propsParams.kycStatus == '未通过审核'){
          return this.isShowPop = true;
        }
      };
      this.$router.push({
        name: "plans",
        query: {
          iccid: this.$route.query.iccid,
          type:1
        }
      });
    },
    // 停机保号充值套餐
    shutdowNum(){
      this.$router.push({
        name: "plans",
        query: {
          iccid: this.$route.query.iccid,
          type:2
        }
      });
    },
    // 判断是否是微信浏览器
    isWeiXin() {
      let ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    // 跳转套餐详情
    details(monthFlow,id){
      // if(monthFlow == "畅享"){
      //   this.$router.push({
      //     name: "enjoyDetails",
      //     query: {
      //       iccid: this.$route.query.iccid,
      //       id:id
      //     }
      //   });
      // }else{
      //   return false
      // }
    },
    //获取详情
    getCard(){
      let params= {
        code:this.code,
        iccid:this.$route.query.iccid,
      };
      wx_flow(params).then(res=>{
        if(res.data.code == 200){
          this.zjdata =  res.data.data
        }
      })
      wx_card(params).then(res => {
        if(res.data.code == 200){
          this.xw_xianshi = this.isWeiXin() ? true:false;
          this.propsParams = res.data.data;
          // hasAgreement 0 没有签约  1有签约
          this.hasAgreementShow = this.propsParams.hasAgreement == "0" ? false : true;
          this.propsParams.cardStatus = this.transferCardStatus(this.propsParams.showStatus);
          this.propsParams.kycStatus = this.realnamestatus(this.propsParams.kycStatus);
          this.platform = this.propsParams.platform;
          if(this.platform == 'gykj'){
            this.externalShow = false
          }
          // 限速的弹窗 0 没有限速  1 限速
          // this.speedDialog = this.propsParams.speedStatus == 0 ? false:true;
          console.log("this.propsParams.kycStatus",this.propsParams.kycStatus, this.propsParams.needKyc);
          if(this.propsParams.needKyc == 1){
            if(this.propsParams.kycStatus == '未实名' || this.propsParams.kycStatus == "未通过审核"){
              this.isShowPop = true;
            }else{
              this.isShowPop = false;
            }
          }
          // newCard 1 未补卡  2 已补卡

          //新用户领流量的弹窗
          if(this.propsParams.canReceive == 1){
            this.flowShow = true
          };
          // //销户的弹窗
          // if(this.propsParams.cardStatus == "已销户" && this.propsParams.newCard == "1"){
          //   this.dialogShow = true;
          //   this.baonumber = true;
          //   this.recharge = true;
          //   this.flowShow = false;
          // }else if(this.propsParams.cardStatus == "已销户" && this.propsParams.newCard == "2"){
          //   this.dialogShow = false;
          //   this.baonumber = true;
          //   this.recharge = true;
          //   this.flowShow = false;
          // }else if(this.propsParams.cardStatus == "已补卡"){
          //   this.recharge = true;
          //   this.baonumber = true;
          // };
          //销户的弹窗
          if(this.propsParams.cardStatus == '已销户' || this.propsParams.cardStatus == '预销户'){
            this.dialogShow = true;
            this.baonumber = true;
            this.recharge = true;
            this.flowShow = false
          }else if(this.propsParams.cardStatus == "已补卡"){
            this.recharge = true;
            this.baonumber = true;
          }

          if(this.propsParams.expireTime == null){
            this.propsParams.expireTime == ""
          }else{
            this.propsParams.expireTime = this.propsParams.expireTime.substr(0,10);
          };
          if(this.propsParams.operationName == "中国移动"){
            this.mobileType = 1;
            // this.imgsrc = require("../assets/img/mobile-logo.svg");
          }else if(this.propsParams.operationName == "中国电信"){
            this.mobileType = 2;
            // this.imgsrc = require("../assets/img/telecom-logo.svg");
          }else{
            this.mobileType = 3;
            // this.imgsrc = require("../assets/img/unicom-logo.svg");
          }

          if(this.propsParams.showKf == '0'){
              this.chatShow = false;
          }
        }else if(res.data.code == 304){
          this.pageShow = true;
          this.pageShowMsg = res.data.message
          return
        }else{
          this.$toast.fail(res.data.message)
        }
      })
    },
    // tab切换
    // 1 生效中 2 未生效 3.已失效
    tabSwitch(index = 0,callback) {
      let params= {
        iccid:this.$route.query.iccid,
        status:index + 1
      }
      wx_product(params).then(res =>{
        if(res.data.code == 200){
          this.packageList = res.data.data;
          this.packageList.map(item =>{
            if(item.productName == null){
              this.propsParams.expireTime == "";
            }
            item.usePercent = (item.usePercent * 100).toFixed(0);
            if(item.endTime == null){
              item.endTime = '无'
            }else{
              item.endTime = item.endTime.substr(0,10);
            }
          })
        }else{
          this.packageList = [];
        }
        if (callback && typeof callback === 'function') {
          callback(this.packageList);
        }
      })
    },
    // 刷新状态
    refresh(){
      location.reload();
    },
    //智能检测
    detection(){
      this.$toast.loading('加载中...',{
        duration:500,
        coverColor: "rgba(0,0,0,0.5)",
        closeOnClickOverlay: true,
        loadingRotate:true
      });
      if(!!this.propsParams.iccid){
          const detectionResult = [];
          if(parseInt(this.propsParams.showStatus)<5){
              this.showRobotTip = true;
          }
          let cardStatus = this.transferCardStatus(this.propsParams.showStatus);
          //套餐剩余
          let surplusFlow = this.zjdata.surplusFlow;
          let status = parseInt(this.propsParams.showStatus)<5?'卡片状态正常':cardStatus;
          detectionResult.push({title:'套餐可用流量',value:surplusFlow});
          detectionResult.push({title:'卡片状态',value:cardStatus});
          detectionResult.push({title:'检测结果',value:status});
          this.titles = detectionResult;
      }
      this.dialogDetectionShow = true;
    },
    // 签约后的解约
    rescindButton(){
       this.$router.push({
        name: "rescindPage",
        query: {
          iccid: this.$route.query.iccid,
        }
      });
    },
    //获取绑定的数据
    getBangd(){
      let params={
        code:this.code,
        bind:1,
        channel:localStorage.getItem("channel")
      }
      wx_record(params).then(res=>{
        if(res.data.code == 200){
        let arr = res.data.data;
        let obj = {};
        // 将数组转化为对象
        for (let key in arr) {
            obj[key] = arr[key];
        };
        let newObj = Object.keys(obj).map(val => ({
            label: obj[val],
            value: obj[val]
        }));
        this.listData.push(newObj)
        }
      })
    },
    // 根据积分去个人中心
    ck_get(){
      // localStorage.setItem("addCardIccid",this.propsParams.iccid)
      // this.$router.push({
      //   name: "userCenterPersona",
      // });
      // return
      if(this.isWeiXin()){
        localStorage.setItem("addCardIccid",this.propsParams.iccid)
        this.$router.push({
          name: "userLogin",
        });
      }else{
        wx_card_qrcode({iccid:this.$route.query.iccid}).then(res =>{
          if(res.data.code == 200){
            document.getElementById("qrcodeDom").innerHTML=''; //先清空之前生成的二维码
            this.$nextTick(()=>{
              new QRCode('qrcodeDom',{
                width: 344,
                height:344,
                text: res.data.data,  //需要转换的链接
                render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                background: '#f0f',   // 背景色
                foreground: '#ff0'    // 前景色
              })
            })
            this.show_ewm = true;
          }
        });
      }
    },
    // 补卡跳转
    cancelBtn(){
      this.$router.push({
        name: "replacementCard",
        query: {
          iccid: this.propsParams.iccid,
        }
      });
    },
    // 领流量跳转
    flowBtn(){
      this.$router.push({
        name: "collarFlow",
        query: {
          iccid: this.$route.query.iccid,
        }
      });
    },
    // 限速跳转详情
    speedDialogBtn(){
      this.$router.push({
        name: "enjoyDetails",
        query: {
          iccid: this.$route.query.iccid,
          id:this.propsParams.cardProductId
        }
      });
    },
    //跳转主页
    switchHome(){
      this.$router.push({
        name: "loop"
      });
    },
    handleMessageBuy(){
      this.$router.push({ path:'/msg/product?iccid='+this.$route.query.iccid});
    },
    handleMessageSend(){
      this.$router.push({ path:'/msg/send?iccid='+this.$route.query.iccid});
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href;
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
  },
  created() {
    let params = {
      url: window.location.href,
      channel:localStorage.getItem("channel")
    };
    if(localStorage.getItem("channel") == 'gykj'){
        this.externalShow = false
    }
    let channel = this.getUrlParam("channel");
    if('gykj' == channel){
      localStorage.setItem("channel","gykj")
      this.externalShow = false
    }
    wx_Auth(params).then(res => {
      let dataObj = res.data.data;
      this.datas = res.data.data;
      let getAppid = dataObj.appId;
      let getTimestamp = dataObj.timestamp;
      let getNonceStr = dataObj.nonceStr;
      let getSignature = dataObj.signature;
      wx.config({
        debug: false,
        appId: getAppid,
        timestamp: getTimestamp,
        nonceStr: getNonceStr,
        signature: getSignature,
        // jsApiList: ['wx-open-launch-weapp'],
        jsApiList:["updateAppMessageShareData", "updateTimelineShareData", "hideMenuItems"], // 必填，需要使用的JS接口列表
        openTagList: ["wx-open-launch-weapp"]
      });
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ['wx-open-launch-weapp'],
          success: function(res) {
          }
        });
      });
      wx.error(function (res) {
        // 如果初始化失败，可以在这里处理错误
      });
    });
  },
  mounted(){
    window.document.title = "流量卡信息";
    if(this.isWeiXin()){
      this.code = localStorage.getItem("code");
    }else{
      this.code = "";
      sessionStorage.setItem("userId",this.$route.query.userId);
    };
    this.getCard();
    let that = this;
    this.tabSwitch(0,function(data){
      if(data.length == 0){
        that.tabSwitch(1)
        that.tabIndex = 1;
      }
    });
    this.getBangd();
    this.$toast.loading('加载中...',{
      duration:800,
      coverColor: "rgba(0,0,0,0.5)",
      closeOnClickOverlay: true,
      loadingRotate:true
    });
    // console.log(localStorage.getItem("channel"));
    this.ylShow = localStorage.getItem("channel") == "qhyl" ? false : true;
    if(localStorage.getItem("channel") == "wx1"){
        this.chatShow = false;
        this.ylShow = false;
    }
    this.checkIsShowCardCertTip(); // 判断实名
  }
};

</script>
<style scoped lang="less">
  .no-data{
    width:10.33333333rem;
    height:9.6rem;
  }
  .page{
    background: #fafafa;
    font-family: PingFangSC-Medium,PingFang SC;
    .zt_class{
      color: #f94040 !important;
      border: 1px solid #f94040 !important;
    }
    #card-switch{
        color: #1890ff;
        border: 1px solid #1890ff;
        font-size: 12px;
        border-radius: 4px;
        padding: 2px;
    }
    .popup .pupbg {
      position: absolute;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.5;
      z-index: 10;
    }
    .plane-content {
      position: fixed;
      width: 90%;
      top: 50%;
      left: 50%;
      margin: -175px 0 0 -45%;
      background: #fff;
      font-size: 14px;
      border-radius: 10px;
      overflow: hidden;
      z-index: 11;
      padding-bottom: 20px;
    }
    .plane-content .plane-header {
        background: #F94040;
        padding: 15px 20px 0;
        position: relative;
    }
    .plane-content .plane-body {
        margin-top: -2px;
    }
    .plane-content .plane-footer {
        padding-top: 10px;
    }
    .plane-content button.close {
        float: right;
        font-weight: 700;
        line-height: 1;
        -webkit-appearance: none;
        padding: 0;
        cursor: pointer;
        background: 0 0;
        border: 0;
        opacity: 0.5;
        text-shadow: none;
        color: #fff;
        font-size: 25px;
        position: absolute;
        top: 2px;
        right: 5px;
    }
    .plane-content .plane-body-text {
        background: #F94040;
        padding: 0 25px 10px;
        font-size: 15px;
        color: #fff;
        text-indent: 2em;
    }
    .plane-content .realName-tip {
        padding: 0 20px;
    }
    .plane-content .realName-tip h6 {
        font-size: 16px;
        line-height: 30px;
        color: #1a1a1a;
        margin: 10px 0 0;
        font-weight: normal;
    }
    .plane-content .realName-tip p {
        font-size: 13px;
        color: #999;
        line-height: 20px;
    }
    .plane-content .btn-right {
        display: block;
        width: 80%;
        font-size: 16px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        background: #F94040;
        color: #fff;
        outline: none;
        border: none;
        border-radius: 10px;
        margin: 0 auto;
    }

    .nut-col{
      border-radius: 4px;
      background: #F94040;
      color: #fff;
      .nut-row{
        margin-top: 6px;
        margin-bottom: 8px;
      }
      .flex-content{
        display: flex;
        justify-content:center;
        align-items:center;
        .flex-content-flow{
            font-size: 26px;
            font-weight: 600;
        }
      }
      .row-button{
        img{
          display: block;
          float: none !important;
          height: 30px;
          float: left;
          font-size: 48px;
        }
        .row-button-img-customer{
          background-size:cover;
          animation: dongHua normal 1.2s infinite ease-in-out;
        }
        @-webkit-keyframes dongHua {
          0% {
              opacity:1;
          }
          50% {
              opacity:0.3;
          }
          100% {
              opacity:1;
          }
        }

      }
    }

    // 页面开始   实名的弹窗
    .layout-header{
      margin-bottom: 5px;
      .lyh_top{
        padding: 20px 10px 5px;
        width: 100%;
        display: flex;
        background: #ffffff;
        .lyh_l{
          max-width: 25%;
          text-align: center;
          position: relative;
          top:-1px
        }
        .lyh_r{
          margin-left: 15px;
          line-height: 25px;
          .title {
            font-size: 20px;
          }
          .sub-tlt {
            font-size: 16px;
            color: #555555;
            white-space: nowrap;
            .ck_class {
              color: #0186D3;
              // text-decoration: underline;
              margin-left: 10px;
              font-size: 14px;
            }
          }
        }
      }
      .status-line {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        padding: 0 15px;
        box-sizing: border-box;
        background: #ffffff;
        .status-wrap {
          display: flex;
          p{
            padding: 0 2px;
            height: 22px;
            line-height: 20px;
            text-align: center;
            border: 1px solid #3bce9e;
            color: #3bce9e;
            font-size: 12px;
            border-radius: 3px;
            margin-right: 5px;
            // &:first-child {

            // }
          }
        }
        .mark-box {
          span{
            display: inline-block;
            width: 55px;
            text-align: center;
            height: 22px;
            line-height: 22px;
            padding: 0;
            font-size: 12px;
            border-radius: 3px;
            background: #F94040;
            color: #ffffff;
            position: relative;
            top: 1px;
          }
          button {
            margin-left: 4px;
            width: 74px;
            height: 22px;
            line-height: 22px;
            padding: 0;
            font-size: 12px;
            border-radius: 3px;
            color: #fff;
            background-color: #1890ff;
            border-color: #1890ff;
          }
        }
      }
      .p_sm{
        position: relative;
        top: 1px;
      }
      .lyh_bot{
        padding: 0px 10px;
        p{
          padding-top: 10px;
          color: #FFFFFF;
          font-size: 13px;
        }
        .p1{
          text-align: center;
          font-size: 12px;
          padding-top: 5px;
        }
      }
    }
    .detail-flow{
      width: 100%;
      background: #F94040;
      color: #ffffff;
      padding: 20px 20px;
      box-sizing: border-box;
      position: relative;
      .p1{
        display: flex;
        justify-content: space-between;
        .p1-sy{
          font-size: 30px;
          font-weight: bold;
        }
      }
      .p2{
        margin-top: 23px;
        font-weight: bold;
        .p2-y{
          display: inline-block;
          margin-left: 10px;
        }
      }
      .kefu{
        position: absolute;
        right: 20px;
        top: 58px;
        i{
          display: inline-block;
          width: 50px;
          height: 50px;
          background: url(../../assets/img/right_fixedbg.png)no-repeat 5px -1141px;
          background-size:cover;
          animation: dongHua normal 1.2s infinite ease-in-out;
        }
        @-webkit-keyframes dongHua {
          0% {
              opacity:1;
          }
          50% {
              opacity:0.3;
          }
          100% {
              opacity:1;
          }
        }
        span{
          position: relative;
          top: -26px;
        }
      }
    }
    .detail-box{
      margin-top: 10px;
      width: 100%;
      position: relative;
      /deep/ .nut-tab-link {
        font-size: 14px;
      }
      /deep/ .nut-tab-title {
        height: 40px;
        line-height: 40px;
      }
      .li_class{
        margin-top: 15px;
        padding: 5px 13px;
        background: #fff;
        width: 100%;
        height: 80px;
        font-size: 13px;
        border-bottom: 2px solid #EDEDED;
        .li_class_left{
          display: flex;
          justify-content: space-between;
          .li_class_mame{
            margin-top: 5px;
            width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .li_class_time{
            margin-top: 5px;
            width: 43%;
          }
        }
        .is-state{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 15px;
          span{
            display: inline-block;
            width: 50px;
            text-align: center;
          }
          /deep/ .nut-progress{
            width: 75%;
          }
        }
        // .is-state{
        //   width: 100%;
        //   height: 5px;
        //   line-height: 5px;
        //   display: flex;
        //   justify-content: space-around;
        //   margin: 5px 0;
        //   .is-div1{
        //     width: 85%;
        //     border-radius: 10px;
        //     background: #F94040;
        //   }
        //   .is-div2{
        //     width: 14%;
        //   }
        // }
        /deep/ .nut-progress{
          margin: 5px 0;
          // margin-top: 8px;
          .nut-progress-text{
            // color: #999;
          }
          .nut-progress-outer{
            background-color:#EDEDED
          }
        }
        .div-yl{
          // margin-top: 8px;
          display: flex;
          justify-content: space-between;
        }
      }
      /deep/ .nut-tab{
        padding: 0;
        border: none;
      }
      /deep/ .nut-tab-item{
        // height: auto;
        height: 200px;
        padding: 0;
      }
      /deep/ .nav-bar{
        background: #F94040!important;
      }
      /deep/ .nut-tab-active{
        .nut-tab-link{
          color:#F94040 !important;
        }
      }
    }
    .div_tips{
      width: 100%;
      background: #F8F8F8;
      position: fixed;
      bottom: 0;
      padding: 10px;
      .div_tips_wrap {
        position: relative;
        p{
          .shutdownNumber{
            // width: 75px;
            // height: 25px;
            // background: #F94040;
            // border:1px solid #F94040;
            // color: #fff;
            // border-radius: 4px;
            // width: 68px;
            // height: 18px;
            font-size: 13px;
            border: none;
            border-bottom: 1px solid #0186D3;
            background: #F8F8F8;
            color:#0186D3;
          }
        }
        .p_tips{
          color: #F94040;
          font-size: 14px;
        }
        .btn-line {
          margin: 10px 0 5px;
          display: flex;
          justify-content: center;
          button{
            border-radius: 10px;
            width: 55%;
            margin-left: 0;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            // background:#F94040 !important ;
            border: 1px solid #F94040 !important;
          }
        }
      }
    }
    .nut-textinput{
      width: 100%;
      margin-bottom:20px ;
    }
    .nut-button{
      margin-left: 40px;
      background: #F94040;
    }
  }
  .flowShow-class{
    /deep/ .nut-dialog-body{
      padding: 25px 20px 10px !important;
    }
    /deep/ .nut-dialog-title{
      color: #F94040;
      font-size: 20px !important;
    }
    /deep/ .nut-dialog-content{
      font-size: 20px;
      margin-top: 10px;
    }
    /deep/ .nut-dialog-btn:only-child{
      color:#F94040 ;
      font-size: 16px;
    }
  }
  .speedDialog-class{
    /deep/ .nut-dialog-content{
      padding-bottom:0px !important;
    }
  }
  /deep/ .popup-box{
    width: 80%;
    #qrcodeDom{
      display: flex;
      justify-content: center;
      canvas{
        width: 80% !important;
        height: 80% !important;
      }
    }

  }
  @-webkit-keyframes masked-animation {
    0%{
      background-position: 0 0;
    }
    100%{
      background-position: -100% 0;
    }
  }
  @media screen  and (max-width: 320px) {
    .li_class_left{
      font-size: 12px;
    }
    .div-yl{
      font-size: 12px !important;
    }
  }
</style>

